.root {
  display: flex;
  flex-shrink: 0;
  min-height: 24px;

  & + & {
    margin-top: 1rem;
  }

  @media (--md-down) {
    flex-direction: column-reverse;
  }
}

.content {
  position: relative;
  width: 100%;
  min-height: 42px;

  @media (--md-up) {
    margin-left: 1.5rem;
  }

  &:first-child {
    margin-left: 0;
  }
}
